import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../usecases/object";
import { v4 as uuidv4 } from "uuid";

export default class NegativeRecordsCompanyViewPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getAffialiateOutSide();
    this.getAccessRequest();
    this.getObject();
  }

  async getAffialiateOutSide() {
    const collection = "affiliates";
    const query = {
      where: {
        group: "OUTSIDE",
        isShowOutSide: true,
      },
    };

    try {
      const response = await findObjectUseCase().execute(collection, query);
      this.view.setOutSideClient(response);
    } catch (error) {}
  }

  async getAccessRequest() {
    const { id: userID } = this.view.getCurrentUser();
    const id = this.object.id || this.view.getObjectId();

    try {
      const [request] = await findObjectUseCase().execute("access_request", {
        where: {
          record_requested: { id },
          requestor: { id: userID },
          status: "Request for Access",
        },
      });

      this.view.setAccessRequestObject(request);
    } catch (error) {
      this.view.showError(error);
    }
  }

  onRequestAccessChange(value, field) {
    const object = this.view.state.requestAccessObject;
    object[field] = value;
    console.log("clg change", object);
    this.view.setRequestAccessObject(object);
  }

  async submitRequest() {
    try {
      this.view.showProgress();
      const currentUser = this.view.getCurrentUser();
      const { object, requestAccessObject } = this.view.state;

      console.warn("qw", object);

      // GET LAST REQUEST NUMBER
      const [request] = await findObjectUseCase().execute("access_request", {
        limit: 1,
        sort: { createdAt: -1 },
      });

      const data = {
        ...requestAccessObject,
        record_requested: object,
        requestor: currentUser,
        request_number: (request?.request_number || 0) + 1,
      };

      data.record_requested = { id: data.record_requested?.id };
      data.no_record_requested = { id: data.record_requested?.id };
      data.requestor = { id: data.requestor?.id };
      data.approverName = object?.lockedTo?.id;
      data.requestedDate = new Date().toISOString();

      if (object?.noRecord) {
        data.no_record = true;
      }

      console.log("data send: ", data);

      await this.upsertUseCase.execute("access_request", data);
      this.getAccessRequest();
      toast.success("Request Submitted!", { position: "top-right" });
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  async getObject() {
    const id = this.object.id || this.view.getObjectId();
    if (!id) return;

    const collection = this.view.getCollectionName();
    const currentUser = this.view.getCurrentUser();

    try {
      this.view.showProgress();

      const query = {
        where: { id },
        include: ["lockedTo.affiliate", "lockedTo.branch"],
      };

      // Try records first, fallback to no_records
      let results = await findObjectUseCase().execute("records", query);
      if (!results?.length) {
        results = await findObjectUseCase().execute("no_records", query);
      }

      this.object = results[0];
      if (!this.object) {
        this.view.hideProgress();
        return;
      }

      // Handle locking if not already locked
      if (!this.object.hasOwnProperty("lockedTo")) {
        await this.handleRecordLocking(collection, currentUser);
      }

      this.view.setObject(this.object);

      // Fetch related data in parallel
      await this.fetchRelatedData(currentUser);

      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  async handleRecordLocking(collection, currentUser) {
    const lockData = {
      lockedTo: { id: currentUser?.id },
      lockedDate: new Date().toISOString(),
      searchNameId: uuidv4(),
    };

    if (this.object?.company) {
      const cases = await findObjectUseCase().execute(collection, {
        where: { company: this.object.company },
      });
      await this.lockCases(collection, cases, lockData);
    } else {
      const { firstName, middleName, lastName, alias } = this.object;
      const cases = await findObjectUseCase().execute(collection, {
        where: { firstName, middleName, lastName, alias },
      });

      const outsideClients = this.view.state.outSideClient || [];
      const outsideNames = outsideClients.map((out) => out.name);

      const [userInfo] = await findObjectUseCase().execute("users", {
        where: { id: currentUser.id },
        include: ["all"],
        keys: ["affiliate"],
      });

      const isOutsideClient = outsideNames.includes(userInfo?.affiliate?.name);

      if (!isOutsideClient) {
        await this.lockCases(collection, cases, lockData);
        this.view.reload();
      }

      this.object.lockedTo = currentUser;
    }
  }

  async lockCases(collection, cases, lockData) {
    console.log("Cases", cases);
    console.log("Cases", cases, lockData);
    const lockPromises = cases.map((item) =>
      this.upsertUseCase.execute(collection, { ...item, ...lockData })
    );
    await Promise.all(lockPromises);
  }

  async fetchRelatedData(currentUser) {
    const affiliateID = this.object?.lockedTo?.affiliate?.id;

    // Build court cases query based on record type
    const casesQuery = this.object.company
      ? { where: { company: this.object.company } }
      : {
          where: {
            firstName: this.object.firstName,
            middleName: this.object.middleName,
            lastName: this.object.lastName,
            alias: this.object.alias,
          },
        };

    // Fetch all related data in parallel
    const [cases, contacts, accessHistory, userAffBranch] = await Promise.all([
      this.object.noRecord
        ? Promise.resolve([])
        : findObjectUseCase().execute("records", casesQuery),
      findObjectUseCase().execute("users", {
        where: { affiliate: { id: affiliateID } },
      }),
      findObjectUseCase().execute("access_history", {
        where: { record: { id: this.object.searchNameId } },
        limit: 5,
        include: ["accessor.affiliate", "accessor.branch"],
      }),
      findObjectUseCase().execute("users", {
        where: { id: currentUser.id },
        include: ["all"],
      }),
    ]);

    this.view.setCourtCases(cases || []);
    this.view.setContactPersons(contacts);
    this.view.setAccessHistory(accessHistory || []);
    this.view.setUserAffBranch(userAffBranch);
  }
}
